import React, { useState } from "react";
import Button from "@mui/material/Button";

import TextField from "@mui/material/TextField";
import { IVISAxios } from "../../Modules/Axios/IVISAxios";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

const BuyerInfo = ({ vehicleData, inquiryHandler }) => {
  const [dealerData, setDealerData] = useState({
    repName: vehicleData.dealerRepName,
    crn: vehicleData.dealerCrn,
    companyName: vehicleData.dealerCompanyName,
    ssNumber: vehicleData.dealerSSNumber,
    companyAddress: vehicleData.dealerCompanyAddress,
    salesAt: vehicleData.dealerSalesAt,
    companyTel: vehicleData.dealerCompanyTel,
    bank: vehicleData.bank,
    accntNo: vehicleData.accntNo,
    ...(vehicleData.type === "노후차" && {
      salesOfficeLocation: vehicleData.dealerSalesOfficeLocation,
    }),
  });

  const saveDealerInfo = async () => {
    try {
      await IVISAxios.patch(
        "/indvreduction/dealer",
        new URLSearchParams({
          vin: vehicleData.vin,
          dealerData: JSON.stringify(dealerData),
        })
      );
      alert("딜러 정보 저장이 완료되었습니다.");
      inquiryHandler();
    } catch (error) {
      console.error(error);
    }
  };

  const loadDealerInfo = async () => {
    try {
      const res = await IVISAxios.get(`/dealer/crn/${vehicleData.crn}`);
      setDealerData(res.data);
      alert("불러오기가 완료되었습니다.");
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (key) => (e) => {
    setDealerData((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const baseFields = [
    { label: "대표자명", key: "repName" },
    { label: "상호", key: "companyName" },
    { label: "주소", key: "companyAddress", span: 2 },
    { label: "판매 · 반출장소", key: "salesAt" },
    { label: "사업자등록번호(숫자만입력)", key: "crn" },
    { label: "주민등록번호", key: "ssNumber" },
    { label: "전화번호", key: "companyTel" },
    { label: "은행", key: "bank" },
    { label: "계좌번호", key: "accntNo" },
  ];

  const extraFieldsByType = {
    노후차: [{ label: "판매장 소재지", key: "salesOfficeLocation", span: 2 }],
  };

  const fields = [
    ...baseFields,
    ...(extraFieldsByType[vehicleData?.type] ?? []),
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 1, gap: 2 }}>
      <Grid container spacing={1}>
        {fields.map(({ label, key, span }) => (
          <Grid item xs={12} sm={span === 2 ? 12 : 6} key={key}>
            <TextField
              label={label}
              value={dealerData[key] ?? ""}
              onChange={handleChange(key)}
              fullWidth
            />
          </Grid>
        ))}
      </Grid>

      <Box sx={{ display: "flex", gap: 1 }}>
        <Button fullWidth variant="contained" onClick={loadDealerInfo}>
          딜러사 정보 불러오기
        </Button>
        <Button fullWidth variant="contained" onClick={saveDealerInfo}>
          딜러사 정보 저장
        </Button>
      </Box>
    </Box>
  );
};

export default BuyerInfo;
